import { render, staticRenderFns } from "./Sidecart.vue?vue&type=template&id=bf5a34dc&"
import script from "./Sidecart.vue?vue&type=script&lang=js&"
export * from "./Sidecart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports